import { render } from "./singleassociation.vue?vue&type=template&id=59ebb892&scoped=true"
import script from "./singleassociation.vue?vue&type=script&lang=js"
export * from "./singleassociation.vue?vue&type=script&lang=js"

import "./singleassociation.vue?vue&type=style&index=0&id=59ebb892&lang=css"
import "./singleassociation.vue?vue&type=style&index=1&id=59ebb892&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ebb892"]])

export default __exports__